import {SvgProps} from '../svgProps';
import {useSvg} from '../useSvg';

export function RainbowSvg(props: SvgProps) {
  const {fill, gradientMaybe} = useSvg(props);
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={props.className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.69633 6.00688C6.79128 5.92563 6 6.64491 6 7.65504V24.2541C6 24.8177 6.50016 25.3746 7.19427 25.4308C10.1538 25.6701 15.7782 26.7195 18.8321 31.3003C21.2318 34.9 21.9284 38.1799 22.077 40.356C22.1358 41.2169 22.8213 41.855 23.4396 41.855H40.3929C41.3548 41.855 42.0313 41.1387 41.9911 40.304C41.7746 35.8082 40.4144 26.1144 33.2318 17.4952C25.8591 8.64796 13.3139 6.51123 7.69633 6.00688ZM4 7.65504C4 5.57237 5.69981 3.81959 7.87517 4.0149C13.556 4.52491 26.8421 6.70353 34.7682 16.2149C42.3415 25.3028 43.7617 35.4934 43.9888 40.2078C44.0899 42.3077 42.3689 43.855 40.3929 43.855H23.4396C21.5337 43.855 20.1949 42.1496 20.0817 40.4923C19.9531 38.6103 19.3466 35.6777 17.1679 32.4097C14.6613 28.6498 9.89401 27.6556 7.03305 27.4243C5.43527 27.2951 4 25.9899 4 24.2541V7.65504Z'
        fill={fill}
      />
      <defs>{gradientMaybe}</defs>
    </svg>
  );
}
